<script setup lang="ts">
const props = defineProps<{ variant: CrystallizeProductVariant, title?: string }>()

const { loggedIn } = useUserSession()

const { threshold, count } = useLicenseInformation()

const price = computed(() => formatPrice({
  price: props.variant,
  interval: 'yearly',
}))
</script>

<template>
  <div class="bg-white rounded-4xl py-l px-s flex flex-col gap-l items-center">
    <div class="flex flex-col gap-s items-center">
      <span class="font-heading">Abonnement</span>
      <h4 class="title-l !font-light text-center" v-text="title" />
    </div>

    <div class="flex gap-m justify-between">
      <NettbutikkProductVerticalCardPrice v-if="!loggedIn || count <= threshold" class="flex-1" title="Små bedrifter" :subtitle="`1-${threshold} ansatte`">
        <div class="flex flex-col" :aria-label="price.label">
          <span data-dd-privacy="mask">{{ price.text }},<br>per ansatt</span>
          <span class="text-base text-secondary font-normal" v-text="price.suffix" />
        </div>
      </NettbutikkProductVerticalCardPrice>
      <div v-if="!loggedIn" aria-hidden="true" role="presentation" class="bg-carbon-100 mx-xs self-stretch bg- w-px" />
      <NettbutikkProductVerticalCardPrice v-if="!loggedIn || count > threshold" class="flex-1" title="Store bedrifter" :subtitle="`${threshold + 1} eller flere ansatte`">
        Pris etter avtale
      </NettbutikkProductVerticalCardPrice>
    </div>
    <Button
      color="blurple"
      variant="primary"
      size="large"
      :to="{
        name: 'info-page',
        params: {
          slug: 'kontakt-salgsavdelingen',
        },
      }"
    >
      Kontakt oss for tilbud
    </Button>

    <div class="py-s -mb-l -mx-s rounded-b-4xl px-l bg-carbon-50 text-center">
      Juridika kjøpes til hele bedriften, totalsummen avhenger av antall ansatte.
    </div>
  </div>
</template>
